
import { defineComponent } from "vue";
import KTModalCard from "@/components/cards/Card.vue";
import KTNewCardModal from "@/components/modals/forms/NewCardModal.vue";

export default defineComponent({
  name: "new-card",
  components: {
    KTModalCard,
    KTNewCardModal,
  },
});
